import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "react-loading-skeleton/dist/skeleton.css"; // Keep this high in index.js
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "mapbox-gl/dist/mapbox-gl.css";
import "./theme.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/index";
import { Toaster } from "react-hot-toast";

const App = lazy(() => import("./App"));
// const appStartTime = performance.now(); // capture start timea
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense>
        <React.StrictMode>
          <App />
          <Toaster
            toastOptions={{
              position: "bottom-right",
              style: {
                background: "#283046",
                color: "#fff",
              },
            }}
          />
        </React.StrictMode>
      </Suspense>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
